<template>
    <div class="row">
        <div class="col-md-12">
            <div class="speq-settings">
                <b-card no-body>
                    <b-tabs v-model="tabIndex" medium card>
                        <b-tab title="Order Limit Settings" class="color-333333">
                            <SpeqOrderLimitSettings  />
                        </b-tab>
                        <b-tab title="Pricelist Settings" class="color-333333">
                            <SpeqPricelistSettings  />
                        </b-tab>
                        <b-tab title="Flag Settings" class="color-333333">
                            <SpeqFlagSettings  />
                        </b-tab>
                        <!-- <b-tab title="Edit profile">
                            I'm the second tab
                            <b-card>I'm the card in tab</b-card>
                        </b-tab>
                        <b-tab title="Premium Plan" disabled>Sibzamini!</b-tab>
                        <b-tab title="Info">I'm the last tab</b-tab> -->
                    </b-tabs>
                </b-card>
            </div>
            </div>
            </div>
</template>

<script>
import {computed, onMounted} from 'vue';
import {useStore} from "vuex";

import SpeqOrderLimitSettings from "./SpeqOrderLimitSettings.vue"
import SpeqPricelistSettings from "./SpeqPricelistSettings.vue"
import SpeqFlagSettings from "./SpeqFlagSettings.vue"


export default {
    props: [],
	emits: [],
	components: {
        SpeqOrderLimitSettings,
        SpeqPricelistSettings,
        SpeqFlagSettings
	},
    setup(){
        const store = useStore();

        let user = computed(function () { return store.state.user });

		onMounted(() => {
            
		});

		return {
            user
		}
	},
	data() {
		return {
            tabIndex: 0
		}
	},
    mounted() {
        
    },
	methods: {
        
	}
}
</script>